import {jwtDecode} from "jwt-decode";

interface JwtPayload {
    exp: number;
    "WPID": any;
    "ADMINORG": any;
    "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name": string;
    "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress": string;
    "http://schemas.microsoft.com/ws/2008/06/identity/claims/role": string;
    "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier": string;
    "USE_ATAC_FLOW": string;
    "permission": any;
}

interface JwtDecoded {
    "WPIDClaim": any;
    "ADMINORGClaim": any;
    "userRole": string;
    "userEmail": string;
    "userName": string;
    "userIdent": string;
    "token": string;
    "atacFlow": boolean;
    "permissions": any;
}

export const getDecodedTokenDetails = async (): Promise<JwtDecoded | null> => {
    const token = localStorage.getItem("token");
    if (!token) {
        console.log('No token found in localStorage');
        return null;
    }

    try {
        const decodedToken = jwtDecode<JwtPayload>(token);
        const decoded: JwtDecoded = {
            ADMINORGClaim: decodedToken["ADMINORG"] ?? '',
            WPIDClaim: decodedToken["WPID"] ?? '',
            userEmail: decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"] ?? '',
            userIdent: decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"] ?? '',
            userRole: decodedToken["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] ?? '',
            userName: decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"] ?? '',
            token: token ?? '',
            atacFlow: decodedToken["USE_ATAC_FLOW"]?.toLowerCase() === 'true',
            permissions: decodedToken["permission"] ?? ''
        };
        return decoded;
    } catch (error) {
        console.error('Failed to decode token', error);
        return null;
    }
}